<template>
    <el-container>
        <el-main >
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                <el-row >
                    <el-col :span="5" v-if="orgType == 1" class="cls-col">
                        <el-form-item label="所属机构" prop="orgCode">
                            <el-select size="small" placeholder="所属机构" clearable v-model="searchData.orgCode" style="width: 100%" clearable >
                                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="所属分类" prop="selectedOption">
                            <el-cascader
                                expand-trigger="hover"
                                change-on-select="true"
                                size="small"
                                clearable
                                :options="categoryOptions"
                                v-model="searchData.selectedOption"
                                style="width: 100%"
                                :props="{ value: 'ccId', label: 'ccName'}"
                                @change="changeCategory">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="课程名称" prop="courseName">
                            <el-input v-model="searchData.courseName" placeholder="课程名称" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="状态" prop="status" >
                            <el-select v-model="searchData.commodityStatus" clearable style="width: 100%"  placeholder="状态" clearable  size="small" >
                                <el-option label="已上架" :value="1"></el-option>
                                <el-option label="已下架" :value="0"></el-option>
                                <el-option label="未上架" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                   
                </el-row>
                <el-form-item >
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>

            </el-form>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addCommodity" class="but-cls">添加</el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteCommodityMore" class="but-cls">删除</el-button>
            <el-button type="primary" icon="el-icon-upload2" size="small" round @click="shelves(1)" class="but-cls">上架</el-button>
            <el-button type="primary" icon="el-icon-download" size="small" round @click="shelves(0)" class="but-cls">下架</el-button>
            <el-table
                    :data="commodityData"
                    border
                    @selection-change="handleSelectionChange"
                    highlight-current-row
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                        fixed="left"
                >
                </el-table-column>
                <el-table-column
                        prop="courseName"
                        fixed
                        label="商品名称"
                       >
                </el-table-column>
                <el-table-column
                    prop="orgName"
                    label="所属机构">
                </el-table-column>
                <el-table-column
                        prop="commodityStatus"
                        :formatter="f_status"
                        label="状态"
                        >
                </el-table-column>
                <el-table-column
                    prop="ccName"
                    label="商品分类">
                </el-table-column>
                <el-table-column
                        prop="preferential"
                        label="现价">
                </el-table-column>
                <el-table-column
                    prop="isView"
                    label="是否展示"
                    :formatter="f_isView"
                >
                </el-table-column>
                <el-table-column
                        prop="validity"
                        label="课程有效日期"
                        :formatter="monthFormat"
                >
                </el-table-column>
                <el-table-column
                        prop="sort"
                        label="自营排序"
                        width="80"
                        align="center"
                        v-if="loginOrgCode != 'blcuonline'"
                >
    
                    <template slot-scope="{row,$index}">
                        <input class="edit-cell" ref="myInput" :id="['input'+row.commodityId]"  v-if="showEdit[row.commodityId]" @blur="changeSort(row)"  v-model="row.sort" >
                        <span v-if="!showEdit[row.commodityId]" @click="handleEdit($index, row)">{{row.sort}}</span>
                        <!--<el-tag type="primary" close-transition v-if="!showEdit[row.commodityId]" @click="handleEdit($index, row)"> {{row.sort}}</el-tag>-->
                    </template>
                </el-table-column>
                <el-table-column
                    prop="orgSort"
                    align="center"
                    label="机构排序">
                    <template slot-scope="{row,$index}">
                        <input class="edit-cell" ref="myInput" :id="['inputOrg'+row.commodityId]"  v-if="showOrgEdit[row.commodityId]" @blur="changeOrgSort(row)"  v-model="row.orgSort" >
                        <span v-if="!showOrgEdit[row.commodityId]" @click="handleOrgEdit($index, row)">{{row.orgSort}}</span>
                        <!--<el-tag type="primary" close-transition v-if="!showEdit[row.commodityId]" @click="handleEdit($index, row)"> {{row.sort}}</el-tag>-->
                    </template>
                </el-table-column>
                <el-table-column
                    prop="persionNum"
                    label="报名人数">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间"
                    :formatter="dateFormat"
                    width="200"
                >
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="updateCommodity(scope.row)" v-if="scope.row.commodityStatus != 1" >编辑</el-button>
                        <el-button @click="deleteCommodity(scope.$index, scope.row)" v-if="scope.row.commodityStatus != 1" type="text" size="small">删除</el-button>
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="copyClick(scope.row)" type="text" size="small">复制</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                :current-page.sync="currentPage"
                @current-change="handleCurrentChange"
                style="margin-top: 5px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js';
    import {dateFormat} from '@/api/utils.js';

    const formData = {

    };
    export default {
        data() {
            return {
                formData: JSON.parse(JSON.stringify(formData)),
                total: 0,
                commodityData: [],
                searchData: {
                    size: 0,
                    page: 1,
                    courseName: '',
                    ccId: '',
                    selectedOption: [],
                    commodityStatus: '',
                    lessonType: '',
                    pccId: '',
                    courseType: '0',
                    orgCode: '',
                },
                categoryOptions: [],
                courseData:[],
                courseChild: [],
                courseChildData : {},
                showEdit: [],
                showOrgEdit: [],
                pageSize:10,
                multipleSelection: [],
                currentPage: 1,
                org: [],
                loginOrgCode: '',
                orgType:''
            };
        },
        methods: {
         copyClick(row) {
                console.log(row,":row.commodityId");
                this.$confirm('此操作将复制该条信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        commodityId: row.commodityId
                    };
                    https.fetchPost('/commodityInfo/copyCommodity',params , 'json').then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '复制成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    );
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消复制'
                    });
                });
            },
            
              changeCategory() {
              },
            handleCurrentChange(val) {
                this.search(val);
            },
              handleClick(row) {
                let url = https.commodityURL+'?commodityId='+ row.commodityId;
                if(this.loginOrgCode == 'blcuonline') {
                  url = https.yhCommodityURL+'?commodityId='+ row.commodityId;
                }
                
                window.open(url, '_blank');
              },
            handleSizeChange() {},
            f_status(row, column, cellValue, index) {
                if(cellValue == 1) {
                    return '已上架';
                }
                if(cellValue == 0){
                    return '已下架';
                }
                if(cellValue == 2){
                    return '未上架';
                }
            },
              f_isView(row, column, cellValue, index) {
                if(cellValue == 1) {
                  return '展示';
                }
                if(cellValue == 0){
                  return '不展示';
                }
              },
            f_lessonType(row, column, cellValue, index) {
                if(cellValue == '1') {
                    return '直播';
                }
                if(cellValue == '2') {
                    return '面授';
                }
                if(cellValue == '3') {
                    return '录播';
                }
                if(cellValue == '4') {
                    return '录播+直播';
                }
                return '其他';
            },
            shelves(commodityStatus) {

                let m = '';
                if(commodityStatus == 1) {
                    m = '上';
                } else {
                    m = '下';
                }
                let length = this.multipleSelection.length;
                this.$confirm('此操作将'+m+'架'+length+'条商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let multipleSelection = this.multipleSelection;
                    let commodityIdString = '';
                    for(let i in multipleSelection) {
                        commodityIdString += multipleSelection[i]+',';
                    }
                    commodityIdString = commodityIdString.substr(0,commodityIdString.length-1);
                    let params = {
                        commodityStatus: commodityStatus,
                        commodityIdString: commodityIdString
                    };
                    https.fetchPost('/commodityInfo/updateComStatusByCommodityId',params , 'json').then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    );

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '操作已取消'
                    });
                });
            },
            handleEdit(index, row) {
                this.showEdit[row.commodityId] = true;
                this.search();
                setTimeout(function() {
                  document.getElementById("input"+row.commodityId).focus();
                }, 100);
            },
              handleOrgEdit(index, row) {
                this.showOrgEdit[row.commodityId] = true;
                this.search();
                setTimeout(function() {
                  document.getElementById("inputOrg"+row.commodityId).focus();
                }, 100);
              },
            changeSort(val) {
                const reg = /^\d{1,3}$/;
                if(!reg.test(val.sort)) {
                    this.$message.error('最多输入3位数字');
                    return;
                }
                this.updateSort(val, 0);
            },
          changeOrgSort(val) {
            const reg = /^\d{1,3}$/;
            if(!reg.test(val.orgSort)) {
              this.$message.error('最多输入3位数字');
              return;
            }
            this.updateSort(val,1);
          },
            updateSort(row,sortType) {
              let params = {};
              if(sortType == 0) {
                  params = {
                    commodityId: row.commodityId,
                    sort: row.sort
                  };
              }
              if(sortType == 1) {
                params = {
                  commodityId: row.commodityId,
                  orgSort: row.orgSort
                };
              }
              https.fetchPost('/commodityInfo/updateSortByCommodityId',params ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.$message({
                            message: '排序成功',
                            type: 'success'
                        });
                        if(sortType == 1) {
                          this.showOrgEdit[row.commodityId] = false;
                        }
                        if(sortType == 0) {
                            this.showEdit[row.commodityId] = false;
                        }
                        
                      this.isFocus = false;
                      this.search();
                    } else {
                        this.$message.error('操作失败:'+msg);
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                );
            },
            addCommodity() {
                this.$router.push('/mall/addCommodity');
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue;
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].commodityId;
                }
            },
            updateCommodity(row) {
                this.$router.push({
                    name: 'addCommodity',
                    query: {commodityId: row.commodityId}
                });
            },
            deleteCommodityMore() {
                let length = this.multipleSelection.length;
                this.$confirm('此操作将删除'+length+'条商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let multipleSelection = this.multipleSelection;
                    let commodityIdString = '';
                    for(let i in multipleSelection) {
                        commodityIdString += multipleSelection[i]+',';
                    }
                    let params = {
                        commodityIdString: commodityIdString
                    };
                    https.fetchPost('/commodityInfo/deleteListByCommodityId',params , 'json').then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    );

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteCommodity(index, row) {
                //deleteIsRecommendByCommodityId
                this.$confirm('此操作将删除该用户信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        commodityIdString: row.commodityId
                    };
                    https.fetchPost('/commodityInfo/deleteListByCommodityId',params , 'json').then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络异常！');
                        }
                    );

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            monthFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    if(cellValue == -1) {
                        return '永久';
                    } else {
                        return cellValue+"天";
                    }
                } else {
                    return cellValue;
                }
            },
            search(val) {
              if(this.searchData.selectedOption.length > 0) {
                this.searchData.ccId = this.searchData.selectedOption[this.searchData.selectedOption.length-1];
              } else {
                this.searchData.ccId = "";
              }
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                this.searchData.size = 10;
                let params = this.searchData;
                https.fetchPost('/commodityInfo/selectListAll',params, 'json' ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.commodityData = data.data.data;
                        this.total = data.data.total;
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }

                }).catch(err=>{
                        console.log(err);
                    }
                );
            },
            loadCourseCategory() {
                let params = {
                  orgCode: this.$store.state.eblcuOrg
                };
              if(this.loginOrgCode == 'blcuonline') {
                params.orgCode = 'blcuonline';
              }
                https.fetchPost('/courseCategoryInfo/selectListRecursion',params, 'from' ).then((data) => {
                    let code = data.data.code;
                    if(code == 200) {
                        this.categoryOptions = data.data.data;
                        // for(let index in d) {
                        //     this.courseData.push(d[index]);
                        //     this.courseChildData[d[index].ccId] = d[index].children;
                        // }
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                );
            },
          selectOrg() {
            this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.org = data.data.data;
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }

            }).catch(err => {
                  console.log(err);
                  this.$message.error('网络错误');
                }
            );
          },

          changeCourse2(val) {
            if(!val) {
              this.searchData.pccId='';
            }
          },
            changeCourse(val) {
              if(val) {
                this.courseChild = this.courseChildData[val];
                if(this.courseChild.length > 0) {
                  this.searchData.ccId = this.courseChild[0].ccId;
                } else {
                  this.searchData.ccId = '';
                }
              } else {
                this.searchData.ccId = '';
              }
            },
        },
        created: function () {
            this.orgType = this.$store.state.orgType;
            this.searchData.orgCode = this.$store.state.orgCode;
            this.loginOrgCode = this.$store.state.orgCode;
            this.search();
            this.selectOrg();
            this.loadCourseCategory();
        }
    };
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
    .line {
        text-align: center;
    }
    .edit-cell {
        width: 60%;
        outline-style: none ;
        border: 1px solid #ccc;
        border-radius: 3px;
        padding: 3px 4px;
        font-size: 12px;
        font-family: "Microsoft soft";
    }
    .edit-cell:focus{
        border-color: #66afe9;
        outline: 0;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)
    }
</style>
